// SEQ-234: Supabase Storage refuses object keys with characters outside a
// safe set (an en dash in a file name returned POST 400). Every upload that
// builds a key from a user's file name uses this one rule, the same one the
// vault and project image uploads already apply inline.
//
// Only the storage KEY is cleaned. Keep the real file name for display.

export function safeStorageFileName(name: string): string {
  return name.replace(/[^a-zA-Z0-9._-]/g, "_");
}

export function commsAttachmentPath(
  projectId: string,
  noteId: string,
  timestamp: number,
  index: number,
  fileName: string,
): string {
  // The index keeps two files in one message apart when cleaning makes their
  // names identical (for example "a-b.pdf" with an en dash and an em dash).
  return `${projectId}/${noteId}/${timestamp}_${index}_${safeStorageFileName(fileName)}`;
}

// Shortens a long file name for a toast title, keeping the extension, so one
// unbroken name cannot spill past the toast box.
export function shortFileName(name: string, max = 36): string {
  if (name.length <= max) return name;
  const dot = name.lastIndexOf(".");
  const ext = dot > 0 && name.length - dot <= 8 ? name.slice(dot) : "";
  return `${name.slice(0, Math.max(1, max - ext.length - 3))}...${ext}`;
}

// Thrown when a Comms attachment upload is refused, so the caller can name the
// file in plain words instead of showing the raw storage error.
export class AttachmentUploadError extends Error {
  fileName: string;
  override cause: unknown;
  constructor(fileName: string, cause: unknown) {
    super(`Upload failed for "${fileName}"`);
    this.name = "AttachmentUploadError";
    this.fileName = fileName;
    this.cause = cause;
  }
}
